import { debugFactory } from '@iva/debugger';
var DEBUG_CONFIG = {
    bColor: '#8086ff',
    fColor: '#fff',
    name: 'CONSENT',
};
var logger = debugFactory(DEBUG_CONFIG);
export { logger };
